module.exports = {
      id: "5baa56a5a23a1b768e0d3680e2f4d1fdequipment-network-wiring.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#5baa56a5a23a1b768e0d3680e2f4d1fdequipment-network-wiring.svg",
      toString: function () {
        return this.url;
      }
    }